import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import { FC } from 'react';

import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';

const Menu: FC = () => (
  <AppBar component='nav'>
    <Container sx={{ paddingX: { lg: '40px' } }}>
      <Toolbar>
        <MobileMenu />
        <DesktopMenu />
      </Toolbar>
    </Container>
  </AppBar>
);

export default Menu;
